import { createAsyncThunk } from '@reduxjs/toolkit';
import estimateApi from '~/apis/estimate';
import {
  CREATE_ESTIMATE,
  GET_ESTIMATE,
  GET_ESTIMATE_ITEMS,
  GET_ESTIMATE_LIST,
  UPDATE_ESTIMATE,
} from '~/utils/constants/actionType';
import {
  IBodyCreateEstimate,
  IParamsGetEstimateList,
  IResponseGetEstimate,
  IResponseGetEstimateItems,
  IResponseGetEstimateList,
} from '~/utils/interface/estimate';
import { IResponseGetFile } from '~/utils/interface/file';

export const handleGetEstimateList = createAsyncThunk<
  IResponseGetEstimateList,
  { jobId: string; data: IParamsGetEstimateList }
>(GET_ESTIMATE_LIST, async ({ jobId, data }, { rejectWithValue }) => {
  try {
    const res = await estimateApi.getEstimateList(jobId, data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleGetEstimateItems = createAsyncThunk<IResponseGetEstimateItems, { jobId: string }>(
  GET_ESTIMATE_ITEMS,
  async ({ jobId }, { rejectWithValue }) => {
    try {
      const res = await estimateApi.getEstimateItems(jobId);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateEstimate = createAsyncThunk<IBodyCreateEstimate, { jobId: string; data: IBodyCreateEstimate }>(
  CREATE_ESTIMATE,
  async ({ jobId, data }, { rejectWithValue }) => {
    try {
      const res = await estimateApi.createEstimate(jobId, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetEstimate = createAsyncThunk<IResponseGetEstimate, string>(
  GET_ESTIMATE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await estimateApi.getEstimate(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGeneratePDF = createAsyncThunk<IResponseGetFile, string>(
  GET_ESTIMATE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await estimateApi.generatePDF(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleSendDocument = createAsyncThunk<null, { id: string; data: any }>(
  GET_ESTIMATE,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await estimateApi.sendDocument(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleRevokeDocument = createAsyncThunk<null, string>(
  GET_ESTIMATE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await estimateApi.revokeDocument(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateEstimate = createAsyncThunk<
  IBodyCreateEstimate,
  { estimateId: string; data: IBodyCreateEstimate }
>(UPDATE_ESTIMATE, async ({ estimateId, data }, { rejectWithValue }) => {
  try {
    const res = await estimateApi.updateEstimate(estimateId, data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
